module.exports = __webpack_public_path__ + "img/mirka-pertroleum.ff1b147d.webp";